<template>
  <div>
    <BranchForm mode="create" :loading="false" @submit="handleCreate" />

    <!-- Notification Toasts -->
    <div id="success-notification-content" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-9" />
      <div class="ml-4 mr-4">
        <div class="font-medium">{{ $t('branch.created') }}!</div>
      </div>
    </div>
    <div id="failed-notification-content" class="toastify-content hidden flex">
      <XCircleIcon class="text-theme-6" />
      <div class="ml-4 mr-4">
        <div class="font-medium">{{ $t('branch.notCreated') }}!</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import Toastify from 'toastify-js'
import branchApi from '../../services/branches/branch.api'
import BranchForm from '@/components/branches/BranchForm.vue'

const router = useRouter()

const handleCreate = async (payload) => {
  try {
    await branchApi.createBranch(payload)

    Toastify({
      node: cash('#success-notification-content').clone().removeClass('hidden')[0],
      duration: 5000,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true
    }).showToast()

    router.push({ name: 'side-menu-branches' })
  } catch (error) {
    console.error('Create Error', error)
    Toastify({
      node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
      duration: 10000,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true
    }).showToast()
  }
}
</script>
